import { Injectable, inject } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { MyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { LoggerFactory, SportsRemoteLogger } from '@frontend/sports/common/core/feature/logging';
import { ExpiringCache } from '@frontend/sports/common/core/utils/expiring-cache';
import { OpenBetsSummary } from '@frontend/sports/types/models/my-bets';
import { catchError, firstValueFrom, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SummaryApiService {
    private apiService = inject(ApiService);
    private myBetsConfig = inject(MyBetsConfig);

    private readonly logger: SportsRemoteLogger;
    private mybetsStatsCache: ExpiringCache;

    constructor() {
        const loggerFactory = inject(LoggerFactory);

        this.logger = loggerFactory.getLogger('MyBetsApiService');

        const timeout = (this.myBetsConfig.cacheTimeout || 100) / 1000;
        this.mybetsStatsCache = new ExpiringCache(timeout);
    }

    async getOpenBetsCount(): Promise<OpenBetsSummary> {
        const source = this.apiService.get<OpenBetsSummary>('mybets/stats').pipe(
            catchError((error) => {
                this.logger.error(error, 'Get OpenBetsCount response failed.');

                return of({
                    openEvents: {},
                    openBetsCount: 0,
                    liveBetsCount: 0,
                    betNumbers: [],
                    isMigrationSummary: false,
                    hasError: false,
                });
            }),
        );

        return firstValueFrom(this.mybetsStatsCache.getOrCreate(`mybets-stats`, source));
    }
}
